var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-5"},[_c('page-header',{attrs:{"title":"View Refund","return_button":true,"action_button":false,"action_button_text":"","action_button_link":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }